<template>
    <div>
        <div>
            <v-col cols="12" xl="10">
                <v-row>
                    <v-col class="py-0" cols="12" lg="3">
                        <b-date-picker-store
                            ref="cnrd_date"
                            :disabled="disabledCnrdDate"
                            :label="t('patients::form.label.cnrd_date')"
                            to-mutate="patients::patient.health_information.cnrd_date"
                        ></b-date-picker-store>
                    </v-col>

                    <v-col class="py-0" cols="12" lg="3">
                        <b-select
                            :label="t('patients::form.label.patient_status')"
                            :rules="validationRules.status"
                            :select-items="patientStatusOptions"
                            mandatory
                            to-mutate="patients::patient.status"
                        ></b-select>
                    </v-col>

                    <v-col class="py-0" cols="12" lg="3">
                        <b-select
                            :label="t('patients::form.label.normal_blood_sample_day')"
                            :select-items="daysOptions"
                            to-mutate="patients::patient.health_information.normal_blood_sample_day"
                        ></b-select>
                    </v-col>

                    <v-col class="py-0" cols="12" lg="3">
                        <b-date-picker-store
                            ref="up_to_including_date"
                            :disabled="disabledUpToIncludingDate"
                            :label="t('patients::form.label.including_date')"
                            to-mutate="patients::patient.health_information.up_to_including_date"
                        ></b-date-picker-store>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" xl="10">
                <v-row>
                    <v-col class="pb-0" cols="12" lg="3">
                        <b-switch
                            :label="t('patients::form.label.checked_cnrd')"
                            class="switch"
                            to-mutate="patients::patient.health_information.is_checked"
                        ></b-switch>
                    </v-col>
                    <v-col class="pb-0" cols="12" lg="3">
                        <b-switch
                            :label="t('patients::form.label.cnrd_entry_found')"
                            class="switch"
                            to-mutate="patients::patient.health_information.cnrd_entry_found"
                        ></b-switch>
                    </v-col>

                    <v-col class="pb-0" cols="12" lg="3">
                        <b-switch
                            :label="t('patients::form.label.is_registered')"
                            class="switch"
                            to-mutate="patients::patient.is_registered"
                            @change="handleIsRegisteredChange"
                        ></b-switch>
                    </v-col>
                    <v-col class="pb-0" cols="12" lg="6">
                        <b-switch
                            :label="t('patients::form.label.ben_diagnosed')"
                            class="switch"
                            to-mutate="patients::patient.health_information.is_with_ben"
                        ></b-switch>
                    </v-col>
                    <v-col class="pb-0" cols="12" lg="6">
                        <b-switch
                            :label="t('patients::form.label.past_history_of_neutropenia')"
                            class="switch"
                            to-mutate="patients::patient.health_information.past_history_of_neutropenia"
                        ></b-switch>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="py-10" cols="12"> &nbsp;</v-col>
        </div>
        <v-dialog v-model="deRegistrationConfirmationModel" max-width="550px" @click:outside="triggerClose">
            <v-card>
                <v-card-title>{{ t('patients::dialog.title.de_registration') }}</v-card-title>
                <v-card-text>
                    <v-sheet>
                        <p>
                            {{ t('patients::alert.de_registration_confirmation') }}
                        </p>
                        <p>
                            {{ t('patients::dialog.text.de_registration', { date: moment().format('YYYY-MM-DD') }) }}
                        </p>
                    </v-sheet>
                    <v-textarea
                        v-model="deregistration_reason"
                        :label="t('patients::dispensing.form.label.reason')"
                        dense
                        mandatory
                        outlined
                        rounded
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-btn rounded @click="triggerClose">
                        {{ t('default::confirmation.close') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="isSaveButtonDisabled" color="primary" rounded @click="triggerSave">
                        {{ t('default::button.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        preview: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deRegistrationConfirmationModel: false,
            deregistration_reason: '',
            daysOptions: [
                { text: 'Monday', value: 'monday' },
                { text: 'Tuesday', value: 'tuesday' },
                { text: 'Wednesday', value: 'wednesday' },
                { text: 'Thursday', value: 'thursday' },
                { text: 'Friday', value: 'friday' },
                { text: 'Saturday', value: 'saturday' },
                { text: 'Sunday', value: 'sunday' },
            ],
            validationRules: {
                status: [(v) => !!v || t('users::validation.field.required')],
            },
        };
    },
    computed: {
        patient() {
            return this.$store.state.patients.patient;
        },
        updatedProps() {
            return this.$store.state.patients.updatedProps;
        },
        disabledCnrdDate() {
            return this.preview || !this.$store.state.patients.patient.health_information.is_checked;
        },
        disabledUpToIncludingDate() {
            return (this.preview || !['deregistered', 'transferred_out'].includes(this.$store.state.patients.patient.status));
        },
        isRegistered() {
            return this.$store.state.patients.patient.is_registered;
        },
        patientStatusOptions() {
            return this.$store.state.patients.patientStatusOptions.filter((x) => x.registered === !!this.isRegistered);
        },
        isSaveButtonDisabled() {
            return this.deregistration_reason.trim().length === 0;
        },
    },
    watch: {
        disabledCnrdDate(val) {
            if (val) {
                this.$store.dispatch('patients/updateProperty', {
                    property: 'patient.health_information.cnrd_date',
                    value: null,
                });
                this.$store.dispatch('patients/updateProperty', {
                    property: 'patientSnapShot.health_information.cnrd_date',
                    value: null,
                });
                this.$refs.cnrd_date.formatedDateValue = null;
            }
        },
        disabledUpToIncludingDate(val) {
            if (val) {
                this.$store.dispatch('patients/updateProperty', {
                    property: 'patient.health_information.up_to_including_date',
                    value: null,
                });
                this.$store.dispatch('patients/updateProperty', {
                    property: 'patientSnapShot.health_information.up_to_including_date',
                    value: null,
                });
                this.$refs.up_to_including_date.formatedDateValue = null;
            }
        },
    },
    methods: {
        getSelectItem(items, value) {
            return items.find((x) => x.value === value) ? items.find((x) => x.value === value).text : null;
        },
        dateFormat(date) {
            return date ? moment(date).format(this.$root.dateFormat) : null;
        },
        handleIsRegisteredChange(value) {
            if (!value) {
                // Value is false, which means switch is turned off
                this.showConfirmationPopup();
            }
        },
        showConfirmationPopup() {
            this.deRegistrationConfirmationModel = true;
        },
        triggerClose() {
            this.deRegistrationConfirmationModel = false;
            this.$store.dispatch('patients/updateProperty', {
                property: 'patient.is_registered',
                value: true,
            });

            this.deregistration_reason = '';
        },
        triggerSave() {
            this.$store.dispatch('patients/updateProperty', {
                property: 'patient.status',
                value: null,
            });
            this.$store.dispatch('patients/updateProperty', {
                property: 'patient.deregistration_reason',
                value: this.deregistration_reason,
            });
            this.deRegistrationConfirmationModel = false;
            this.deregistration_reason = '';
        },
    },
};
</script>

<style></style>
